'use client';

import type { TranslationSnapshotBoundaryComponent } from '@eliadmin/core/src/i18n/translation-snapshot-types';
import dynamic from 'next/dynamic';

const DictionaryBoundary0 = dynamic(() => import('./providers/dictionary-a62c2d3691974441a9f8493e7dd64fccbc07508ce33b70b0580eb7692fe86da3'));
const DictionaryBoundary1 = dynamic(() => import('./providers/dictionary-133df795d4804cd493018c615724c5486863056285040576e9b429c64a31fd29'));

export const GENERATED_TRANSLATION_BOUNDARIES: Readonly<Record<string, TranslationSnapshotBoundaryComponent>> = {
  "en": DictionaryBoundary0,
  "de": DictionaryBoundary1,
};
